import { __assign } from "tslib";
import * as React from 'react';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import * as Swipeable from 'react-swipeable'; // https://www.npmjs.com/package/react-swipeable
//Enums
import Actions from '../../../enums/ActionsEnum';
import WeekStartersEnum from '../../../enums/WeekStartersEnum';
import Popups from '../../../enums/PopupsEnum';
//Components
import WeeklyMobileCalendarStyled from './WeeklyMobileCalendarStyled';
import Calendar from '../Calendar/Calendar';
import { TimeToDisplayWrapperMobile, TimeToDisplayTextWrapperMobile, } from './WeeklyMobileCalendar.styles';
import WeeklyMobileDatesHeader from '../../presentationals/WeeklyMobileDatesHeader';
//Utils
import * as utils from '../Calendar/CalendarUtlis/CalendarUtils';
import getCalendarsPopColors from '../../../utils/getCalendarsPopColors';
import { dateToMomentWithFormat, getAriaLabelStr, shortMomentDate, } from '../../../utils/momentUtils';
import { classes } from './WeeklyMobileCalendar.st.css';
import usePrevious from '../../../hooks/usePrevious';
// Context
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
import WixStylesContext from '../../../context/wixStylesContext';
import getCalendarPropsData from '../../../context/getCalendarPropsData';
import getWixStylesContextData from '../../../context/getWixStylesContextData';
import capitalize from '../../../utils/stringUtils';
var WeeklyMobileCalendar = function (_a) {
    var calendarsProps = _a.calendarsProps;
    var dates = calendarsProps.dates, _b = calendarsProps.action, action = _b === void 0 ? Actions.NO_ACTION : _b, _c = calendarsProps.timezone, timezone = _c === void 0 ? '' : _c, _d = calendarsProps.weekStarter, weekStarter = _d === void 0 ? WeekStartersEnum.Sunday : _d, handleMonthChange = calendarsProps.handleMonthChange, _e = calendarsProps.openPopup, openPopup = _e === void 0 ? null : _e, _f = calendarsProps.isNextDisabled, isNextDisabled = _f === void 0 ? false : _f, _g = calendarsProps.isPrevDisabled, isPrevDisabled = _g === void 0 ? false : _g, _h = calendarsProps.isLiveSite, isLiveSite = _h === void 0 ? false : _h, wixStyles = calendarsProps.wixStyles, datePickerMobileDate = calendarsProps.datePickerMobileDate, locale = calendarsProps.locale, isEditorX = calendarsProps.isEditorX;
    var t = useTranslation()[0];
    var calendar = React.useRef(null);
    var isResponsive = typeof wixStyles.numbers.calendarHeightWeekly === 'undefined'
        ? false
        : wixStyles.numbers.calendarHeightWeekly === 1;
    var isCalendarsShown = typeof wixStyles.booleans.isCalendarsInfoShown === 'undefined'
        ? true
        : wixStyles.booleans.isCalendarsInfoShown;
    var _j = React.useState({ shortDate: '', momentDate: {} }), date = _j[0], setDate = _j[1];
    var _k = React.useState(moment().format('YYYY-MM-DD')), loadDate = _k[0], setLoadDate = _k[1];
    var _l = React.useState(window.innerHeight), height = _l[0], setHeight = _l[1];
    var _m = React.useState(), currentWeekRange = _m[0], setCurrentWeekRange = _m[1];
    var _o = React.useState(''), ariaLabelStr = _o[0], setAriaLabelStr = _o[1];
    var _p = React.useState(moment().format()), headerPickerDate = _p[0], setHeaderPickerDate = _p[1];
    React.useEffect(function () {
        typeof currentWeekRange !== 'undefined' &&
            setAriaLabelStr(getAriaLabelStr(currentWeekRange));
    }, [currentWeekRange]);
    React.useEffect(function () {
        window.addEventListener('resize', function () {
            setHeight(window.innerHeight + 100);
        });
    }, []);
    React.useEffect(function () {
        var dateChangeCheck = function () {
            setInterval(function () {
                var currentDate = moment().format('YYYY-MM-DD');
                if (loadDate !== currentDate) {
                    setLoadDate(currentDate);
                    location.reload();
                }
            }, 1000 * 60 * 60); // 3_600_000) // every hour check if date change
        };
        dateChangeCheck();
    }, [loadDate]);
    var goToDateFromPickers = function (date) {
        var format = 'YYYY-MM-DD';
        var today = dateToMomentWithFormat(new Date(), format);
        var chosenDate = dateToMomentWithFormat(date, format);
        var isFutureDay = chosenDate > today;
        var _a = utils.getStartAndEndMonthDates(date), start = _a.start, end = _a.end;
        handleMonthChange(start, end, timezone, isFutureDay);
        //@ts-ignore
        calendar.current.getApi().gotoDate(date);
    };
    var handleMonthChangeWeekly = function () {
        var format = 'YYYY-MM-DD';
        var today = dateToMomentWithFormat(new Date(), format);
        //@ts-ignore
        var fCalendarWeekStartDate = calendar.current.getApi().currentDataManager
            .data.currentDate;
        var chosenDate = dateToMomentWithFormat(fCalendarWeekStartDate, format);
        var isFutureDay = chosenDate > today;
        var _a = utils.getStartAndEndMonthDates(fCalendarWeekStartDate), start = _a.start, end = _a.end;
        handleMonthChange(start, end, timezone, isFutureDay);
    };
    var goToDateFromPicker = function (date) {
        setDate({
            shortDate: shortMomentDate(date, locale),
            momentDate: moment(date),
        });
        goToDateFromPickers(date);
    };
    React.useEffect(function () {
        goToDateFromPicker(datePickerMobileDate);
    }, [datePickerMobileDate]);
    React.useEffect(function () {
        goToDateFromPicker(headerPickerDate);
    }, [headerPickerDate]);
    var handlePickerClick = function () {
        if (openPopup) {
            return openPopup({
                popup: Popups.DATE_PICKER,
                isCloseFocused: true,
            });
        }
    };
    var onSwipeHandler = function (isLeft) {
        isLeft
            ? //@ts-ignore
                calendar.current.getApi().next()
            : //@ts-ignore
                calendar.current.getApi().prev();
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    };
    var handlers = Swipeable.useSwipeable({
        onSwipedLeft: function (eventData) { return onSwipeHandler(eventData.dir === 'Left'); },
        onSwipedRight: function (eventData) { return onSwipeHandler(eventData.dir === 'Left'); },
        trackMouse: true,
        delta: 200,
    });
    var WeeklyMobile = function () {
        var weekly = (React.createElement("div", __assign({}, handlers),
            React.createElement(WeeklyMobileCalendarStyled, null)));
        var weeklyWithWrapper = (React.createElement("div", { className: classes.WeeklyWithWrapper, style: { height: "".concat(height - 150, "px") } }, weekly));
        var weeklyWithDatesHeader = (React.createElement(React.Fragment, null,
            React.createElement(WeeklyMobileDatesHeader, null),
            isResponsive ? weeklyWithWrapper : weekly));
        return weeklyWithDatesHeader;
    };
    var timeToDisplay = (React.createElement(TimeToDisplayWrapperMobile, null,
        React.createElement(TimeToDisplayTextWrapperMobile, { "aria-label": t('Google_Calendar_Date_Range', {
                dateRange: ariaLabelStr,
            }), onClick: handlePickerClick }, capitalize(date.shortDate, false))));
    var prevLocale = usePrevious(locale);
    React.useEffect(function () {
        if (prevLocale !== locale) {
            setDate({
                shortDate: shortMomentDate(
                //@ts-ignore
                calendar.current.getApi().currentDataManager.data.currentDate, locale),
                momentDate: moment(
                //@ts-ignore
                calendar.current.getApi().currentDataManager.data.currentDate),
            });
        }
    }, [locale]);
    React.useEffect(function () {
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    }, [weekStarter]);
    var onNextPrevTodayClickedHandler = React.useCallback(function (isNext, isToday) {
        var days = isNext ? 7 : -7;
        isToday
            ? //@ts-ignore
                calendar.current.getApi().today()
            : //@ts-ignore
                calendar.current.getApi().incrementDate({ days: days });
        isToday || handleMonthChangeWeekly();
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    }, []);
    return (React.createElement(WeeklyContextMobile.Provider, { value: __assign({ calendarRef: calendar, rerenderTitleHandler: function () {
                return setDate({
                    shortDate: shortMomentDate(
                    //@ts-ignore
                    calendar.current.getApi().currentDataManager.data.currentDate, locale),
                    //@ts-ignore
                    longDate: calendar.current.getApi().currentDataManager.data
                        .viewTitle,
                    momentDate: moment(
                    //@ts-ignore
                    calendar.current.getApi().currentDataManager.data.currentDate),
                });
            }, date: date, dateOnFocuse: date.momentDate, setHeaderPickerDate: setHeaderPickerDate, setCurrentWeekRange: function (data) { return setCurrentWeekRange(data); } }, getCalendarPropsData(calendarsProps)) },
        React.createElement(WixStylesContext.Provider, { value: __assign({}, getWixStylesContextData(wixStyles)) },
            React.createElement(Calendar, { isEditorX: isEditorX, locale: calendarsProps.locale, isTimezoneShown: calendarsProps.isTimezoneShown, error: calendarsProps.error, calendarRef: calendarsProps.calendarRef, dates: dates, handleMonthChange: handleMonthChange, handleSetHeight: calendarsProps.handleSetHeight, isTodayButtonStyleSecondary: calendarsProps.isTodayButtonStyleSecondary, handleTimezoneChange: calendarsProps.handleTimezoneChange, timezone: timezone, isMobile: true, action: action, isNextDisabled: isNextDisabled, isPrevDisabled: isPrevDisabled, openPopup: openPopup, isLiveSite: isLiveSite, onTodayClick: function () { return onNextPrevTodayClickedHandler(false, true); }, handleCellSelect: calendarsProps.handleCellSelect, onPreviousClicked: function () { return onNextPrevTodayClickedHandler(false, false); }, onNextClicked: function () { return onNextPrevTodayClickedHandler(true, false); }, timeToDisplay: timeToDisplay, isWeekly: true, isCalendarsShown: isCalendarsShown, calendarsList: getCalendarsPopColors(wixStyles, calendarsProps.calendarsList, dates), className: classes.CalendarExt }, WeeklyMobile))));
};
export default WeeklyMobileCalendar;
//# sourceMappingURL=WeeklyMobileCalendar.js.map